import { render } from "./ClientSpaceInvoice.vue?vue&type=template&id=886badbc"
import script from "./ClientSpaceInvoice.vue?vue&type=script&lang=js"
export * from "./ClientSpaceInvoice.vue?vue&type=script&lang=js"

import "./ClientSpaceInvoice.vue?vue&type=style&index=0&id=886badbc&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__